import Vue from "vue";
import logoimg from "@/assets/default.png"


// import { LRCHandler } from '@/loopring/handler.js';
// let handler = new LRCHandler(5);



const getImageIpfs = (ipfs, type) => {
    if(ipfs && ipfs!="null") {
		let url=`https://ipfs.upticknft.com/ipfs/${ipfs}`
        return url;
    } else {
        if(type == "avatar") {
            return logoimg;
        }
        return logoimg;
    }
}

const getChainTokenId = (name) => {
    let json = localStorage.getItem("ChainToken");
    if(json) {
        let tokens = JSON.parse(json);
        for (const key in tokens) {
            if (Object.hasOwnProperty.call(tokens, key)) {
                const ele = tokens[key];
                if(ele.name == name) {
                    return ele.tokenId;
                }
            }
        }
    }
    return 0;
}

const getChainByName = (name) => {
    let json = localStorage.getItem("ChainToken");
    if(json) {
        let tokens = JSON.parse(json);
        for (const key in tokens) {
            if (Object.hasOwnProperty.call(tokens, key)) {
                const ele = tokens[key];
                name = name?name : "UPTICK"
                if(ele.name == name) {
                    return ele;
                }
            }
        }
    }
    return { 
        name: "",
        img: "",
        tokenId: ""
    };
}

// const getLogged = async () => {
//     let accountInfo = await handler.getAccountInfoSession();
//     if(accountInfo.accountId > 0) {
//         return true;
//     }
//     return false;
// }

const addressEllipsis = (addr) => {
    if(addr && addr.length > 10) {
        return addr.substr(0, 6) + "..." + addr.substr(-6);
    }
    return "";
}

const filterExt = () => {

}

export function init() {
    // Vue.prototype.LRCHandler = handler;
    Vue.prototype.$walletUnit = "LRC";

    Vue.prototype.getImageIpfs = getImageIpfs;
    Vue.prototype.getChainTokenId = getChainTokenId;
    Vue.prototype.getChainByName = getChainByName;
    Vue.prototype.addressEllipsis = addressEllipsis;

}